import Vue from 'vue';

Vue.prototype.$eventHub = new Vue();

/**
 * Initializes vue and all its components
 */
export default function InitVueApp() {
	Vue.component('audio-player', require('../components/AudioPlayer.vue').default);
	Vue.component('video-presenter', require('../components/VideoPresenter.vue').default);
	Vue.component('milestones', require('../components/Milestones.vue').default);
	Vue.component('progress-switcher', require('../components/ProgressSwitcher.vue').default);
	// Vue.component('tag-name', require('../components/FileName.vue').default);
	var scrolled = false;
	const vueApp = new Vue({
		el: '.page-container',
		mounted() {
			
			// if(!scrolled) {
			// 	setTimeout( () => {
					let anchorid = window.location.hash.substring(1);
					if (anchorid === "" || anchorid === null) return;
					let anchorel = document.querySelector(`#${anchorid}`);

					if (anchorid && anchorel) {
						window.scrollTo({
							top: anchorel.getBoundingClientRect().top - 6 * parseFloat(getComputedStyle(document.documentElement).fontSize),
							left: window.scrollX,
							behavior: 'smooth'
						})
					}
			// 	}, 1000);
			// 	scrolled = true;
			// }
			
		}
	});
}
